import React from 'react';
import proptypes from 'prop-types';
const { string: stringType, arrayOf, shape, number: numberType, bool: boolType, func: functionType } = proptypes;
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { SmartFilter } from './SmartFilter';

const SmartFilterWrapper = ({
  categoryId,
  breadcrumbs,
  categoryName,
  freeText,
  keyword,
  pageType,
  selectedDimensions,
  onSmartFilterResponse,
  onUpdateRefinement
}) => {

  return (
    <ErrorBoundary data-testid="smart-filter-wrapper" id="smart-filter-wrapper" name="smart-filter-wrapper">
      <QueryProvider dataSource="smart-filter" cacheKey="smart-filter">
        <SmartFilter
          categoryId={categoryId}
          breadcrumbs={breadcrumbs}
          categoryName={categoryName}
          freeText={freeText}
          keyword={keyword}
          pageType={pageType}
          selectedDimensions={selectedDimensions}
          onSmartFilterResponse={onSmartFilterResponse}
          onUpdateRefinement={onUpdateRefinement}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
};
SmartFilterWrapper.propTypes = {
  categoryId: stringType,
  breadcrumbs: arrayOf(shape({
    __typename: stringType,
    dimensionName: stringType,
    label: stringType,
    url: stringType,
    refinementKey: stringType
  })),
  categoryName: stringType,
  freeText: stringType,
  keyword: stringType,
  pageType: stringType,
  selectedDimensions: arrayOf(shape({})),
  onSmartFilterResponse: functionType,
  onUpdateRefinement: functionType
};
SmartFilterWrapper.defaultProps = {
  categoryId: '',
  breadcrumbs: [],
  categoryName: '',
  freeText: '',
  keyword: '',
  pageType: '',
  selectedDimensions: [],
  onSmartFilterResponse: () => {},
  onUpdateRefinement: () => {}
};

SmartFilterWrapper.displayName = 'SmartFilterWrapper';

export { SmartFilterWrapper };
